<script lang="ts" setup>
import { useCustomerStore } from '@stores/me/customer'

import { useAppBrand } from '@composables/tools/app-brand.hook'

import LinkProfile from '@Widgets/Menu/LinkProfile.vue'
import LinkPaymentsSubscriptions from '@Widgets/Menu/LinkPaymentsSubscriptions.vue'
import LinkPricing from '@Widgets/Menu/LinkPricing.vue'
import BtnLogOut from '@Widgets/Menu/BtnLogOut.vue'
import LinkReferral from '@Widgets/Menu/LinkReferral.vue'

defineOptions({
  name: 'DropdownMore',
})

const store = useCustomerStore()

const { isSmartestMinds } = useAppBrand()

</script>

<template>
  <LinkProfile />
  <LinkPaymentsSubscriptions />
  <LinkReferral v-if="store.isTypePaid && !isSmartestMinds" />
  <LinkPricing
    v-if="store.isTypePaid"
    view="dropdown-item"
  />
  <BtnLogOut />
</template>
